import { render, staticRenderFns } from "./qaFeedback.vue?vue&type=template&id=5a155942"
import script from "./qaFeedback.vue?vue&type=script&lang=js"
export * from "./qaFeedback.vue?vue&type=script&lang=js"
import style0 from "./qaFeedback.vue?vue&type=style&index=0&id=5a155942&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports